import * as React from 'react';
import Section from '../../components/Section';
import { ColorField, Image } from '../../components/forms';
import { Company } from '../../company';

type Props = {
  company: Company;
  children: React.ReactNode;
  onChange: Function;
};

const setThemeValue = (obj: Company, onChange: Function) => (
  field: string,
  newValue: String,
) =>
  onChange(
    Object.assign({}, obj, {
      theme: {
        ...obj.theme,
        [field]: newValue,
      },
    }),
  );

const setValue = (obj: any, onChange: Function) => (
  field: string,
  newValue: String,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

export default function CompanyAppearance(props: Props) {
  return (
    <Section title="Appearance">
      <div className="flex flex-column flex-row-l">
        <div className="w-100 w-50-l pr3-l">
          <ColorField
            label="Background Color"
            id="background"
            field={['background']}
            defaultValue={props.company.theme.background}
            onValueChange={setThemeValue(props.company, props.onChange)}
          />
          <ColorField
            label="Highlight Color"
            id="key"
            field={['key']}
            defaultValue={props.company.theme.key}
            onValueChange={setThemeValue(props.company, props.onChange)}
          />
        </div>
        <div className="w-100 w-50-l pl3-l">
          <ColorField
            label="Text Color"
            id="body"
            field={['body']}
            defaultValue={props.company.theme.body}
            onValueChange={setThemeValue(props.company, props.onChange)}
          />
          <Image
            label="Image"
            id="image_identifier"
            field={['image_identifier']}
            defaultValue={props.company.image_identifier}
            onValueChange={setValue(props.company, props.onChange)}
          />
        </div>
      </div>
      {props.children}
    </Section>
  );
}
